import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useWorkspaceMembers = (workspaceId: string | undefined) => {
  return useQuery({
    queryKey: QUERY_KEYS.workspaceMembers(workspaceId ?? ''),
    queryFn: () => container.workspaces.listMembers(workspaceId as string),
    enabled: Boolean(workspaceId),
  });
};

export const useUpdateMemberRole = (workspaceId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ memberId, roleId }: { memberId: string; roleId: string }) =>
      container.workspaces.updateMemberRole(workspaceId, memberId, roleId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.workspaceMembers(workspaceId) }),
  });
};

export const useRemoveMember = (workspaceId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (memberId: string) => container.workspaces.removeMember(workspaceId, memberId),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.workspaceMembers(workspaceId) }),
  });
};

export const useLeaveWorkspace = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (workspaceId: string) => container.workspaces.leave(workspaceId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.workspaces }),
  });
};
